import { useSiteContent } from "@/shared/content/SiteContentProvider"
import { Accordion } from "@/shared/ui/Accordion"
import { Disclaimer } from "@/shared/ui/Disclaimer"
import { Section } from "@/shared/ui/Section"
import { ArrowRightSm } from "@/shared/ui/icons"

export function FaqSection() {
  const { faq } = useSiteContent()

  return (
    <Section id="duvidas" tone="white">
      <div className="grid lg:grid-cols-[1fr_2fr] gap-12 lg:gap-20">
        <div className="flex flex-col gap-4 lg:sticky lg:top-28 lg:self-start">
          <span className="text-xs font-semibold tracking-widest uppercase text-dourado-escuro">
            Dúvidas frequentes
          </span>
          <h2 className="text-3xl lg:text-[38px] font-medium text-verde-profundo leading-[1.1] tracking-tight">
            Perguntas frequentes
          </h2>
          <p className="text-base text-verde-profundo/55 leading-relaxed">
            Encontre respostas sobre coberturas, carências, contratação e mais.
          </p>

          <div className="mt-2 flex flex-col gap-2">
            <p className="text-sm text-verde-profundo/45">Ainda com dúvidas?</p>
            <a
              href="#atendimento"
              className="inline-flex items-center gap-2 text-sm font-semibold text-dourado-escuro hover:text-verde-profundo transition-colors"
            >
              Fale com o atendimento
              <ArrowRightSm />
            </a>
          </div>
        </div>

        <div>
          <Accordion items={faq.map((entry) => ({ question: entry.question, answer: entry.answer }))} />

          <Disclaimer className="mt-8">
            As respostas acima são informações gerais e não substituem o regulamento do plano. Consulte os termos
            completos antes da contratação.
          </Disclaimer>
        </div>
      </div>
    </Section>
  )
}
